// src/services/PairService.js
import axios from 'axios';

const API_BASE_URL = 'https://odyhsf2fi9.execute-api.us-east-1.amazonaws.com/preProd'; // Replace with your actual API Gateway URL

const dataService = {
  listDevices: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/things`);
      console.log('List Devices Response:', response.data); // Log the returned data
      return response.data;
    } catch (error) {
      console.error('Error listing devices:', error);
      throw error;
    }
  },

  createDevice: async (deviceData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/things`, deviceData);
      console.log('Create Device Response:', response.data); // Log the returned data
      return response.data;
    } catch (error) {
      console.error('Error creating device:', error);
      throw error;
    }
  },

  getDevice: async (thingName) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/things/${thingName}`);
      console.log('Get Device Response:', response.data); // Log the returned data
      return response.data;
    } catch (error) {
      console.error('Error getting device:', error);
      throw error;
    }
  },

  updateDevice: async (thingName, deviceData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/things/${thingName}`, deviceData);
      console.log('Update Device Response:', response.data); // Log the returned data
      return response.data;
    } catch (error) {
      console.error('Error updating device:', error);
      throw error;
    }
  },

  deleteDevice: async (thingName) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/things/${thingName}`);
      console.log('Delete Device Response:', response.data); // Log the returned data
      return response.data;
    } catch (error) {
      console.error('Error deleting device:', error);
      throw error;
    }
  }
};

export default dataService;
